var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"row"},[_c('CustomFileInput',{attrs:{"className":'col-12',"defaultImg":_vm.defaultImg},on:{"changeValue":function($event){_vm.mediaFile = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }